'use strict';

angular.module('ClinicApp').factory('InsuranceService', function(InsuranceProviderResource) {
  return {
    listInsuranceProviders: function(specialtyIds, region) {
      return InsuranceProviderResource.query({
        specialtyIds: specialtyIds.join(','),
        region: region,
      }).$promise.then(function(insuranceProviders) {
        _.forEach(insuranceProviders, function(insuranceProvider) {
          insuranceProvider.plans = _.compact(insuranceProvider.plans);
        });

        return insuranceProviders;
      });
    },
  };
});
